import { IApp } from '@/interfaces/App';

import { ECheckoutStep } from '@/helpers/enums';
import { ICustomPaymentParameters } from '@/interfaces/CustomPaymentParameters';

export default {
  setPageLoading(state: IApp, isPageLoading: boolean) {
    state.isPageLoading = isPageLoading;
  },
  setCardSelectedLoading(state: IApp, isCardSelectedLoading: boolean) {
    state.isCardSelectedLoading = isCardSelectedLoading;
  },
  setCardSelected(state: IApp, cardFirstDigits: number) {
    state.cardSelected = cardFirstDigits;
  },
  setCardFirstDigits(state: IApp, cardFirstDigits: string | number | null) {
    state.cardFirstDigitsSelected = cardFirstDigits;
  },
  setStepFormSelected(state: IApp, step: any) {
    state.stepFormSelected = step;
  },
  setPaymentMethodSelected(state: IApp, paymentMethodSelected: string) {
    state.paymentMethodSelected = paymentMethodSelected;
  },
  setStep(state: IApp, step: ECheckoutStep) {
    state.step.currentStep = step;
    state.step.percentage = (step * 100) / state.step.totalSteps;
  },
  requestTermsOfUse(state: IApp) {
    state.termsOfUseLoading = true;
  },
  successTermsOfUse(state: IApp, termsOfUse: any) {
    state.termsOfUseLoading = false;
    state.termsOfUse = termsOfUse;
  },
  failureTermsOfUse(state: IApp) {
    state.termsOfUseLoading = false;
  },
  requestPolicy(state: IApp) {
    state.policyLoading = true;
  },
  successPolicy(state: IApp, policy: any) {
    state.policyLoading = false;
    state.policy = policy;
  },
  failurePolicy(state: IApp) {
    state.policyLoading = false;
  },
  setAmountLoading(state: IApp, loading: boolean) {
    state.isAmountLoading = loading;
  },
  setCustomPaymentParameters(state: IApp, parameters: ICustomPaymentParameters) {
    state.customPaymentParamenters = parameters;
  },
};
